import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GetAppIcon from "@mui/icons-material/GetApp";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import { LoaderScreen } from "../../components/LoaderScreen";
import { ParqueMaquinariaTabla } from "./ParqueMaquinariaTabla";
import { ParqueMaquinariaModal } from "./ParqueMaquinariaModal";

// Pantalla de Parque de Maquinaria — mismo patrón visual que los reportes CRM (header + tabla),
// pero SIN filtro de fecha/ADR arriba; solo filtros por columna dentro de la tabla
// (ParqueMaquinariaTabla). Conectada a ParqueMaquinariaCRM/ListadoParqueMaquinaria?idcliente=.
export const CRM_PAQ_Maquinaria = () => {
  const history = useHistory();
  const location = useLocation();
  const idclienteRedirigido = location.state?.idcliente;
  const vieneDeDashboardCRM = location.state?.pantalla === "Dashboard CRM";

  const [listado, setListado] = useState([]);
  const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });
  const [openModal, setOpenModal] = useState(false);
  const [maquinaEditando, setMaquinaEditando] = useState(null);

  const cargarListado = () => {
    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(`ParqueMaquinariaCRM/ListadoParqueMaquinaria?idcliente=${idclienteRedirigido || 0}`)
      .then((result) => {
        // El endpoint puede regresar el array directo o envuelto en { listado: [...] }, según
        // el shape final de AD_Parque_Maquinaria.Listado — se soportan ambos casos.
        setListado(Array.isArray(result) ? result : (Array.isArray(result?.listado) ? result.listado : []));
        setLoader((prev) => ({ ...prev, mostrar: false }));
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("PARQUE DE MAQUINARIA", JSON.stringify(error), "error");
      });
  };

  useEffect(() => {
    cargarListado();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onGeneraExcel = () => {
    setLoader((prev) => ({ ...prev, mostrar: true }));
    request
      .get(`ParqueMaquinariaCRM/ImprimirExcelParqueMaquinaria?idcliente=${idclienteRedirigido || 0}`)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `${filename}.xlsx`;
        downloadLink.click();
        setLoader((prev) => ({ ...prev, mostrar: false }));
      })
      .catch((error) => {
        setLoader((prev) => ({ ...prev, mostrar: false }));
        Swal.fire("PARQUE DE MAQUINARIA", JSON.stringify(error), "error");
      });
  };

  const onAgregarEquipo = () => {
    setMaquinaEditando(null);
    setOpenModal(true);
  };

  const onEditarEquipo = (maquina) => {
    setMaquinaEditando(maquina);
    setOpenModal(true);
  };

  // El endpoint de guardado no regresa el listado actualizado — se vuelve a pedir completo
  const onGuardadoEquipo = () => cargarListado();

  const onRegresar = () => {
    if (idclienteRedirigido) {
      history.push("/DashClientes/Main", { idcliente: idclienteRedirigido });
    } else if (vieneDeDashboardCRM) {
      history.push("/DashClientes/Main");
    } else {
      history.goBack();
    }
  };

  return (
    <div className="crm-main-screen">
      <LoaderScreen loader={loader} />
      <div className="crm-body">
        <div className="crm-page rca-screen">
          <div className="crm-module">
            <div className="crm-module-head">
              <div className="crm-head-grid">
                <div className="crm-head-left">
                  <button className="crm-btn-regresar" onClick={onRegresar}>
                    <ArrowBackIcon /> Regresar
                  </button>
                </div>
                <div className="crm-head-center">
                  <h1 className="crm-module-title">{location.state?.cliente || "Clientes"}</h1>
                  <p className="crm-module-subtitle">PARQUE DE MAQUINARIA</p>
                </div>
                <div className="crm-head-right">
                  <button className="crmcs-btn-excel" onClick={onAgregarEquipo}>
                    <AddCircleOutlineIcon /> Agregar
                  </button>
                  <button className="crmcs-btn-excel" onClick={onGeneraExcel}>
                    <GetAppIcon /> Excel
                  </button>
                </div>
              </div>
              <div className="crm-head-divider">
                <div className="crm-head-divider-dot" />
              </div>
            </div>

            <div className="crm-home-wrapper rca-wrapper scroll">
              <ParqueMaquinariaTabla listado={listado} onEditar={onEditarEquipo} />
            </div>
          </div>
        </div>
      </div>

      <ParqueMaquinariaModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        idcliente={idclienteRedirigido || 0}
        maquina={maquinaEditando}
        onGuardado={onGuardadoEquipo}
      />
    </div>
  );
};
